module.exports = __webpack_public_path__ + "img/brazil.f6231010.png";